
      // Hide loading screen once game starts
      import('./src/main.ts')
        .then(() => {
          setTimeout(() => {
            const loading = document.getElementById('loading-screen');
            if (loading) loading.classList.add('hidden');
          }, 500);
        })
        .catch((err) => {
          console.error('Failed to load game:', err);
          const loading = document.getElementById('loading-screen');
          if (loading) {
            loading.innerHTML = `
          <div class="loading-title">Oops!</div>
          <div class="loading-subtitle">Failed to load the game. Please refresh.</div>
        `;
          }
        });
    